import styled from "styled-components";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import theme from "../../theme/theme";

const Wrapper = styled.div`
  color: #004576;
  width: 100%;

  .heading {
    margin-top: 1em;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .content {
    text-align: start;
    margin-bottom: 3em;
    background-color: white;
    padding: 0.5em 1.5em;
    height: 100%;
    border-radius: 5px;
    border-bottom: 40px solid ${theme.colors.bg};

    & a {
      color: #69c7dd;
    }
  }

  .newsHeading {
    font-weight: 800;
    font-size: 20px;
  }

  .text {
    display: flex;
    flex-direction: column;
    height: 100%;
    color: #000;
  }

  .carousel .control-dots .dot {
    background-color: #8f9498;
  }
`;

const FAQ = () => {
  return (
    <Wrapper>
      <div className="heading">FAQ</div>
      <Carousel
        dynamicHeight={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={788000}
        showArrows={false}
        showStatus={false}
      >
        <div className="content">
          <h2 className="newsHeading">What is Tactive?</h2>
          <p className="text">
            Tactive is a user-friendly platform that combines the best brokerage
            house technology together with world-class strategists to help
            consumers build unique investment portfolios at a nominal fee. As a
            hub for consumers to work directly with financial professionals, the
            platform manages your money for you through guided investment
            practices per particular financial strategy, or a mixture of
            strategies, specific to your needs.
          </p>
        </div>
        <div className="content">
          <h2 className="newsHeading">
            How does Tactive compare to other programs?
          </h2>
          <p className="text">
            Tactive is a “Robo-Advisor,” meaning that you fund your account, and
            our program will automatically rebalance according to your selected
            strategy or group of strategies.
            <br />
            <br /> Other “Robo-Advisor” programs utilize a single investment
            strategy as a sole resource to invest. With Tactive, you not only
            have access to unique strategies that other platforms offer, but you
            also have the opportunity to blend multiple strategists. This makes
            your investment portfolio specifically tailored to you and even more
            diversified.
          </p>
        </div>
        <div className="content">
          <h2 className="newsHeading">How are the strategists chosen?</h2>
          <p className="text">
            Strategists go through their due diligence in completing a rigorous
            vetting process. We look for unique strategists that utilize
            strategies counter to the “buy and hold” philosophy which is
            primarily used within the investment community today. Each
            strategist will be unique in their own right and different from the
            other strategists used within Tactive.
          </p>
        </div>
        <div className="content">
          <h2 className="newsHeading">How do I fund my account?</h2>
          <p className="text">
            Funding your account is simple. To begin creating your account,
            click on the “Get Started” button. This will direct you to the Risk
            Assessment Quiz where you will select a strategy for your liking.
            Depending on the strategy, you will be provided with the appropriate
            funding options. The funding options include:
            <br />
            <br /> - Your current bank account
            <br />
            <br /> - Rollover your old 401k or IRA account
            <br />
            <br /> - Or, simply by check
          </p>
        </div>
        <div className="content">
          <h2 className="newsHeading">What type of accounts can I open?</h2>
          <p className="text">
            You can open up a standard taxable brokerage account, a retirement
            account (both traditional IRA or ROTH IRA), or even a college
            savings account. <br />
            <br />
            <a
              href="https://tactivewealth.com/questions-about-investing/"
              target="_blank"
              rel="noopener noreferrer"
            >
              READ MORE
            </a>
          </p>
        </div>
        <div className="content">
          <h2 className="newsHeading">Can I rollover my old 401k or IRA?</h2>
          <p className="text">
            Of course! We found that many people have an old 401k or IRA account
            that would be a perfect start to funding your subscription. We
            accept all types of accounts whether it be a previous employer’s
            401k plan, a traditional IRA, a ROTH account, or a brokerage account
            from another bank or brokerage firm.
          </p>
        </div>
      </Carousel>
    </Wrapper>
  );
};

export default FAQ;
